module.exports = __webpack_public_path__ + "html/video-gallery_8d05b1e76b1c45e1f15eb0d30de083b6.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/video-gallery.html
// module id = 1Z0F
// module chunks = 1